import { createSelector } from '@ngrx/store';
import { createSlice, PayloadAction } from 'ngrx-slice';

import {
  BasketDiscountCreateRequest,
  BasketDiscountResponse,
} from '@app/api/marketplace/models';

export interface State {
  discounts: Array<BasketDiscountResponse>;
  discountsLoading: boolean;
  discountsLoadingError: boolean;
  discountsSaving: boolean;
  discountsSaveError: boolean;
}

export const initialState: State = {
  discounts: [],
  discountsLoading: false,
  discountsLoadingError: false,
  discountsSaving: false,
  discountsSaveError: false,
};

export const {
  actions: BasketDiscountsActions,
  selectors,
  ...BasketDiscountsFeature
} = createSlice({
  name: 'basketDiscounts',
  initialState,
  reducers: {
    loadDiscounts: {
      trigger: (state) => ({ ...state, discountsLoading: true }),
      success: (
        state,
        action: PayloadAction<{ response: Array<BasketDiscountResponse> }>
      ) => ({
        ...state,
        discounts: action.response,
        discountsLoading: false,
        discountsLoadingError: false,
      }),
      failure: (state) => ({
        ...state,
        discountsLoading: false,
        discountsLoadingError: true,
      }),
    },
    saveDiscounts: {
      trigger: (
        state,
        action: PayloadAction<{
          request: {
            discounts: Array<BasketDiscountCreateRequest>;
            fromSiteId: string;
          };
        }>
      ) => ({ ...state, discountsSaving: true }),
      success: (
        state,
        action: PayloadAction<{ response: Array<BasketDiscountResponse> }>
      ) => ({
        ...state,
        discountsSaving: false,
        discountsSaveError: false,
      }),
      failure: (state) => ({
        ...state,
        discountsSaving: false,
        discountsSaveError: false,
      }),
    },
    deleteDiscounts: {
      trigger: (
        state,
        action: PayloadAction<{
          request: Array<string>;
        }>
      ) => ({ ...state, discountsLoading: true }),
      success: (state) => ({
        ...state,
        discountsLoading: false,
        discountsLoadingError: false,
      }),
      failure: (state) => ({
        ...state,
        discountsLoading: false,
        discountsLoadingError: false,
      }),
    },
  },
});

export const BasketDiscountsSelectors = {
  ...selectors,
  selectSortedDiscounts: createSelector(
    selectors.selectDiscounts,
    (discounts) => {
      const discountsForSort = [...discounts];
      return discountsForSort.sort((discount1, discount2) =>
        (discount1.siteMinOrderValue ?? 0) > (discount2.siteMinOrderValue ?? 0)
          ? 1
          : -1
      );
    }
  ),
};
